export default __webpack_public_path__ + "static/media/logoTextWhite.3756d5ae.png";